import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui';

/**
 * Smart Search Shopping Button
 * Generates search links to golf retailers for specific club recommendations
 */
export function ShoppingButton({ head, shaft, dexterity, variant = 'full' }) {
  if (!head) return null;

  // Construct search query - use head only for broader results
  // Format: "TaylorMade Qi10 Driver" or "Titleist T200 7 Iron"
  const headName = head.name || `${head.manufacturer || ''} ${head.model_name || ''}`.trim();
  const category = head.category || 'Driver';

  // Build search query
  let searchQuery = headName;
  if (!searchQuery.toLowerCase().includes(category.toLowerCase())) {
    searchQuery = `${headName} ${category}`;
  }

  // URL encode the query
  const encodedQuery = encodeURIComponent(searchQuery);

  // Retailer URLs
  const retailers = {
    globalgolf: `https://www.globalgolf.com/search/?q=${encodedQuery}`,
    secondswing: `https://www.2ndswing.com/search.aspx?search=${encodedQuery}`,
  };

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent parent card click
  };

  if (variant === 'compact') {
    return (
      <a
        href={retailers.globalgolf}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className="mt-2 bg-success hover:bg-success-hover text-white text-[10px] font-bold py-1 px-2 rounded w-full text-center flex items-center justify-center gap-1 transition-colors"
      >
        Check Price
      </a>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-2" onClick={handleClick}>
      <a
        href={retailers.globalgolf}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-zinc-800 hover:bg-zinc-700 text-text-primary text-xs font-bold py-2 px-3 rounded text-center flex items-center justify-center gap-1.5 transition-colors"
      >
        <ExternalLink size={12} /> Global Golf
      </a>
      <a
        href={retailers.secondswing}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-zinc-800 hover:bg-zinc-700 text-text-primary text-xs font-bold py-2 px-3 rounded text-center flex items-center justify-center gap-1.5 transition-colors"
      >
        <ExternalLink size={12} /> 2nd Swing
      </a>
    </div>
  );
}

export default ShoppingButton;
